"use strict";

import BetragsrechnerRegistry from "../services";

import BetragsrechnerPersonalkosten from "./betragsrechner.js";
import BetragsrechnerPersonalkostenController from "./controller";

const BetragsrechnerPersonalkostenModul = angular.module("dias.betragsrechner.personalkosten_lohnjournal", [
  BetragsrechnerRegistry.name,
]);

BetragsrechnerPersonalkostenModul.config(/*@ngInject*/ BetragsrechnerRegistryProvider => {
  BetragsrechnerRegistryProvider.register("personalkosten_lohnjournal", BetragsrechnerPersonalkosten);
})
  .component("personalkostenlohnjournal", BetragsrechnerPersonalkostenController);

export default BetragsrechnerPersonalkostenModul;
